// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['vi_VN']  = {
  "name": "vi_VN",
  "day": {
    "abbrev": [
      "CN",
      "T2",
      "T3",
      "T4",
      "T5",
      "T6",
      "T7"
    ],
    "full": [
      "Chủ nhật",
      "Thứ hai",
      "Thứ ba",
      "Thứ tư",
      "Thứ năm",
      "Thứ sáu",
      "Thứ bảy"
    ]
  },
  "month": {
    "abbrev": [
      "Th01",
      "Th02",
      "Th03",
      "Th04",
      "Th05",
      "Th06",
      "Th07",
      "Th08",
      "Th09",
      "Th10",
      "Th11",
      "Th12"
    ],
    "full": [
      "Tháng một",
      "Tháng hai",
      "Tháng ba",
      "Tháng tư",
      "Tháng năm",
      "Tháng sáu",
      "Tháng bảy",
      "Tháng tám",
      "Tháng chín",
      "Tháng mười",
      "Tháng mười một",
      "Tháng mười hai"
    ]
  },
  "meridiem": [
    "AM",
    "PM"
  ],
  "date": "%d/%m/%Y",
  "time24": "%T",
  "dateTime": "%A, %d %B Năm %Y %T %Z",
  "time12": "%I:%M %p",
  "full": "%A, %d %B năm %Y %T %Z"
}

